import React, {Component} from 'react';
import "./TextSearch.css"
import "./commonAnalysisStyle.css"
import $ from "jquery";
import * as _ from "underscore";
import ReactTooltip from 'react-tooltip'

const Highcharts = require('highcharts');

class TextSearch extends Component {
    chart = undefined

    constructor(props) {
        super(props);
        this.state = {backgroundColor: '#000000', listOfKeys: [], fromTo: {}, extraction: 'lemma'}
    }


    componentDidMount() {
        let widget = this

        this.chart = Highcharts.chart(document.getElementById('chartSearch'), {
                chart: {
                    backgroundColor: 'transparent',
                    zoomType: 'x',
                    color: "#fff",
                    type: 'line',
                    height: 300,
                    spacingBottom: 30
                },
                colors: ['#fff',
                    '#9e5aa6',
                    '#d65d57',
                    '#86c069'],
                title: {
                    text: ''
                },
                yAxis: {
                    labels: {enabled: false},
                    gridLineColor: "transparent",
                    lineColor: "transparent",
                    title: null
                },
                subtitle: {
                    text: ' ',
                    x: -20
                },
                xAxis: {
                    lineColor: '#fff',
                    labels: {
                        enabled: false,
                        staggerLines: 1,
                        overflow: 'justify',
                        step: 10
                    },
                    maxZoom: 1, // fourteen days
                    categories: [],
                    tickColor: "transparent"
                },
                tooltip: {
                    valueSuffix: ' Norm Freq'
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'right',
                    verticalAlign: 'top',
                    x: -10,
                    y: 15,
                    borderWidth: 0,
                    itemStyle: {
                        font: '9pt monospace',
                        color: '#ffffff',
                        textOutline: 0
                    }

                },
                plotOptions: {
                    line: {
                        lineWidth: 0.8
                    },
                    series: {

                        allowPointSelect: false,
                        point: {
                            events: {
                                click: function () {
                                    if (widget.state.extraction === "lemma") {
                                        widget.props.callbackParentSelectedYear({year: this.category.replace(/-/g, ""), term: this.series.name});
                                    } else if (widget.state.extraction === "fulltext") {
                                        widget.props.callbackParentSelectedYearFullText(this.category);
                                    }
                                }
                            }
                            // ,
                            // unselect: function () {
                            //     // calculate_widget(widget_id);
                            // }
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: []

            }
        )

        $('#TextSearchBoxForm').submit(function (ev) {
            ev.preventDefault(); // to stop the form from submitting

            let textToSearch = $('#text_search_box').val().toLowerCase();
            widget.performSearch(textToSearch)
            //widget.props.callbackParent( push($("#person_search_box").val()) );
        });

    }


    updateTimeInterval(timeInterval, callback) {
        this.setState({fromTo: timeInterval}, () => {
            callback()
        })
    }


    update(data) {

        let widget = this


        while (widget.chart.series.length > 0) {
            widget.chart.series[0].remove(false);
        }
        widget.chart.xAxis[0].setCategories(data.xAxis)
        // this.chart.series.setData(data.series);

        if (data.hasOwnProperty("series")) {
            data.series.forEach(
                (serie) => {
                    widget.chart.addSeries(serie, false);
                });
        } else {
            widget.chart.addSeries(data.serie, false)
        }
        widget.chart.redraw();
    }


    performSearch(searchString) {

        let widget = this
        let parameters = {
            corpusID: "deg",
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            searchString: searchString,
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            background: "#ec9943"
        }


        let elements = []


        if (this.state.extraction === "lemma") {
            this.setState({
                extraction: "lemma"
            })
            $.ajax({
                type: "POST",
                url: window.apiAlcideUrlPrefix + "lemmaDistributionSearch",
                data: parameters,
                async: true,
                dataType: "json",
                success: function (data) {

                    data.filelist = _.sortBy(data.filelist, 'date');
                   // console.log(data);
                    widget.update(data)
                    widget.props.callbackParent(data.filelist);
                    // data.forEach((i) => {
                    //     elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                    // })
                }
            });
        } else if (this.state.extraction === "fulltext") {
            this.setState({
                extraction: "fulltext"
            })
            $.ajax({
                type: "POST",
                url: window.apiAlcideUrlPrefix + "fullTextSearch",
                data: parameters,
                async: true,
                dataType: "json",
                success: function (data) {

                    data.files = _.sortBy(data.files, 'date');
                    widget.update(data)
                    widget.props.callbackParent(data.files);
                    // data.forEach((i) => {
                    //     elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                    // })
                }
            });
        }


        // this.setState({background: parameters.background})
        //
        // this.setState({items: elements},()=>{
        //     callback()
        // })
    }


    performFulltextSearch(searchString) {

        let widget = this
        let parameters = {
            corpusID: "deg",
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            searchString: searchString,
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            background: "#ec9943"
        }


        this.setState({
            extraction: "fulltext"
        })
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "fullTextSearch",
            data: parameters,
            async: true,
            dataType: "json",
            success: function (data) {
                //console.log(data)
                data.files = _.sortBy(data.files, 'date');
                widget.update(data)
                widget.props.callbackParent(data.files);
                // data.forEach((i) => {
                //     elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                // })
            }
        });

    }


    performLemmatextSearch(searchString) {

        let widget = this
        let parameters = {
            corpusID: "deg",
            rangeYears: this.state.fromTo.fromDate + "-" + this.state.fromTo.toDate,
            sortmethod: "dataInsertion",
            sortdirection: "ASC",
            searchString: searchString,
            fileList: JSON.stringify(this.state.fromTo.filteredFiles),
            background: "#ec9943"
        }

        this.setState({
            extraction: "lemma"
        })
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "lemmaDistributionSearch",
            data: parameters,
            async: true,
            dataType: "json",
            success: function (data) {
                //console.log(data)
                data.filelist = _.sortBy(data.filelist, 'date');

                widget.update(data)
                widget.props.callbackParent(data.filelist);
                // data.forEach((i) => {
                //     elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                // })
            }
        });

    }



    TextSearchOptionChange(value, callback) {
        this.setState({
            extraction: value
        }, () => {
            callback()
        });

    }

    handleOptionChange = (changeEvent) => {
        this.setState({
            extraction: changeEvent.target.value
        }, () => {

        });

    }


    render() {
        return (
            <div id="textSearchDashboard" className="TextSearchWidgetStyle commonAnalysisFeatures">
                <center>
                    <div className="analisysTitle" >Cerca nel testo</div>
                    <form id="TextSearchBoxForm" className="form-wrapper">
                        <input id="text_search_box" type="text" placeholder="Cerca nei documenti..." required/>
                        <button type="submit" style={{color: '#E7C21F'}} data-tip data-for='ttip'>Cerca</button>
                    </form>
                    <div id="lista_radio_textsearch" className="radioList">
                        <input className="magic-radio" type="radio" name="radioTextSearch" id="pTSearch1" value="lemma" checked={this.state.extraction === 'lemma'} onChange={this.handleOptionChange}/>
                        <label htmlFor="pTSearch1">
                            per lemmmi
                        </label>
                        <input className="magic-radio" type="radio" name="radioTextSearch" id="pTSearch2" value="fulltext" checked={this.state.extraction === 'fulltext'} onChange={this.handleOptionChange}/>
                        <label htmlFor="pTSearch2">
                            nel Testo
                        </label>
                    </div>
                    <div id="chartSearch"></div>

                </center>
                <ReactTooltip id='ttip' place="top" type="dark" effect="float" delayShow={500} >

                    Nella ricerca per lemmi scrivere i lemmi separati da spazi (es. pace guerra)<br/>
                    Nella ricerca nel testo scrivere la chiave di ricerca fra virgolette (es. "guerra mondiale" o  "stampa")

                </ReactTooltip>
            </div>
        );
    }
}

export default TextSearch;


// WEBPACK FOOTER //
// ./src/components/TextSearch.jsx